import { FC } from 'react';
import { IconButton } from '@mui/material';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { FormCurrencyField, FormSelect, FormTextField } from '../../../../../lib/components';
import { TooltipComponent } from '../../../../../lib/components/atomic/feedback';
import { InfoIcon } from '../../../../../lib/icons';
import { CompanyForm, CompanyFormProps } from '../../shared/companyForm';
import { KeyofNamespace } from '../../../../../translations/keyofNs';

const EMAIL_FIELDS = ['invoice_email', 'mandate_email'];

type Props = Omit<CompanyFormProps, 'children'>;

export const PaymentDataForm: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <CompanyForm {...props}>
      {Object.keys(typeof props.initialValues === 'object' && props.initialValues).map(
        (key, index) =>
          ['pricing_model', 'payment_interval'].includes(key) ? (
            <FormSelect
              key={index}
              label={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              placeholder={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              name={key}
              options={
                key === 'pricing_model'
                  ? [
                      {
                        value: 'starter_essenszuschuss',
                        text: t('payment:pricing_model', { context: 'starter_essenzuschuss' })
                      },
                      {
                        value: 'starter_mobilitaet',
                        text: t('payment:pricing_model', { context: 'starter_mobilitaet' })
                      },
                      {
                        value: 'starter_sachbezug',
                        text: t('payment:pricing_model', { context: 'starter_sachbezug' })
                      },
                      { value: 'basic', text: t('payment:pricing_model', { context: 'basic' }) },
                      {
                        value: 'complete',
                        text: t('payment:pricing_model', { context: 'complete' })
                      }
                    ]
                  : [
                      {
                        value: 'monthly',
                        text: t('payment:payment_interval', { context: 'monthly' })
                      },
                      {
                        value: 'quarterly',
                        text: t('payment:payment_interval', { context: 'quarterly' })
                      },
                      {
                        value: 'yearly',
                        text: t('payment:payment_interval', { context: 'yearly' })
                      }
                    ]
              }
              xs={6}
              disabled
            />
          ) : key === 'monthly_price_per_employee' ? (
            <FormCurrencyField
              shiftDecimals={2}
              key={index}
              label={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              placeholder={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              name={key}
              disabled
              xs={6}
            />
          ) : (
            <FormTextField
              key={index}
              label={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              placeholder={t(`payment:${key}` as KeyofNamespace<'payment'>)}
              name={key}
              validation={
                EMAIL_FIELDS.includes(key)
                  ? Yup.string().email(t('form:INVALID_EMAIL')).nullable()
                  : Yup.string().nullable()
              }
              endAdornment={
                key === 'mandate_email' ? (
                  <TooltipComponent title={t('payment:mandate_email_hint')} arrow placement="top">
                    <IconButton className="h-5 w-5 p-0">
                      <InfoIcon className="h-5 w-5" />
                    </IconButton>
                  </TooltipComponent>
                ) : undefined
              }
              xs={6}
            />
          )
      )}
    </CompanyForm>
  );
};
